import { Suspense, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { getDocumentPathFromViewSplat } from '#utils/document-app-path';

import {
  DocumentByPathRoute,
  DocumentByPathRouteFallback,
} from './document-by-path-route';

export function DocumentDViewRoute() {
  const params = useParams();
  const pathFromUrl = getDocumentPathFromViewSplat(
    (params as Record<string, string | undefined>)['*'],
  );

  const canRender = useMemo(() => pathFromUrl.length > 0, [pathFromUrl]);

  return canRender ? (
    <Suspense fallback={<DocumentByPathRouteFallback />}>
      <DocumentByPathRoute documentPath={pathFromUrl} />
    </Suspense>
  ) : null;
}
